export enum AmenityType {
  pullThrough = 'Pull Through',
  backIn = 'Back In',
  electricity = 'Electricity',
  water = 'Potable Water',
  dump = 'Dump Station',
  sewage = 'Sewage',
  cell = 'Cell Phone Coverage',
  wifi = 'WiFi',
  firesAllowed = 'Campfires Allowed',
  petsAllowed = 'Pets Allowed',
  trash = 'Trash Provided',
  recycling = 'Recycle Provided',
  table = 'Picnic Table',
  restroom = 'Toilet Available',
  shower = 'Shower',
  laundry = 'Laundry',
  tents = 'Tents Allowed',
  vehicles = 'Vehicles Allowed',
  pool = 'Hot Tub/Pool',
  wheelchair = 'Wheelchair Accessible',
  evCharging = 'EV Charging',
  fireRing = 'Fire Ring',
  outdoorGrill = 'Outdoor Grill',
  generatorOk = 'Generator-Friendly',
  outdoorLighting = 'Outdoor Lighting',
  sunshade = 'Sunshade',
  waterFill = 'Drinking-Water Fill',
  lockableStorage = 'Lockable Storage',
  custom = 'Custom',
}

export interface IAmenityType {
  type:
    | 'pullThrough'
    | 'backIn'
    | 'electricity'
    | 'water'
    | 'dump'
    | 'sewage'
    | 'cell'
    | 'wifi'
    | 'firesAllowed'
    | 'petsAllowed'
    | 'trash'
    | 'recycling'
    | 'table'
    | 'restroom'
    | 'shower'
    | 'laundry'
    | 'tents'
    | 'vehicles'
    | 'pool'
    | 'wheelchair'
    | 'evCharging'
    | 'fireRing'
    | 'outdoorGrill'
    | 'generatorOk'
    | 'outdoorLighting'
    | 'sunshade'
    | 'waterFill'
    | 'lockableStorage'
    | 'custom';
}
